import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AdminDataKeyWordDto } from '../../models/dtos/admindata/adminDataKeyWordDto';


@Injectable({
  providedIn: 'root'
})
export class AdminData_Service {


  private apiUrl = `${environment.apiUrl}/adminDatas`;

  constructor(private http: HttpClient) { }

  getKeyWord(): Observable<AdminDataKeyWordDto[]>{
    return this.http.get<AdminDataKeyWordDto[]>(`${this.apiUrl}/getKeyWord`)
  }

  getWebVersion(): Observable<any>{
    return this.http.get(`${this.apiUrl}/getWebVersion`)
  }

  getGoogleAnalytics(): Observable<any>{
    return this.http.get(`${this.apiUrl}/getGoogle`)
  }


}